import { render, staticRenderFns } from "./MassFeedingFacilityWriteBody.vue?vue&type=template&id=927f0fec&scoped=true"
import script from "./MassFeedingFacilityWriteBody.vue?vue&type=script&lang=js"
export * from "./MassFeedingFacilityWriteBody.vue?vue&type=script&lang=js"
import style0 from "./MassFeedingFacilityWriteBody.vue?vue&type=style&index=0&id=927f0fec&prod&scoped=true&lang=scss"
import style1 from "./MassFeedingFacilityWriteBody.vue?vue&type=style&index=1&id=927f0fec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927f0fec",
  null
  
)

export default component.exports